import { getSdkError } from "../utils/GqlError";
import { sendNewRelicEvent } from "../utils/newRelicEvents";
import { Mfa_Status } from "../__generated__/auth-gate";
import * as api from "./apis/mfaStatus";
export { pollMfaByAppStatus, abortPolling, mfaStatus };
var shouldAbortPolling = false;
var timeoutHandle;
async function mfaStatus(mfaToken, userUuid) {
  try {
    return await api.mfaStatus(mfaToken, userUuid);
  } catch (e) {
    sendNewRelicEvent({
      EventName: 'mfa_status_failed',
      error: e
    });
    throw e;
  }
}
async function pollMfaByAppStatus(args) {
  var _args$pollingOptions, _args$pollingOptions2;
  shouldAbortPolling = false;
  var timeoutDuration = ((_args$pollingOptions = args.pollingOptions) === null || _args$pollingOptions === void 0 ? void 0 : _args$pollingOptions.timeoutDuration) || 10 * 60 * 1000; // Default to 10 minutes
  var pollingInterval = ((_args$pollingOptions2 = args.pollingOptions) === null || _args$pollingOptions2 === void 0 ? void 0 : _args$pollingOptions2.pollingInterval) || 1000; // Default to 1 second

  var keepPollingStatus = args.flow === 'onboarding' ? Mfa_Status.ONBOARDING : Mfa_Status.SENT;
  var startTime = Date.now();
  return poll();
  function poll() {
    clearTimeout(timeoutHandle);
    return new Promise(function (resolve, reject) {
      async function checkStatus() {
        var response;
        var diff = Date.now() - startTime;
        if (diff >= timeoutDuration) {
          reject(getSdkError('Timeout reached', 'polling_timeout', 'mfaStatus'));
          return;
        }
        try {
          response = await mfaStatus(args.mfaToken, args.userUuid);
          if (keepPollingStatus !== response.status || shouldAbortPolling) {
            return resolve(response);
          } else {
            timeoutHandle = setTimeout(checkStatus, pollingInterval);
          }
        } catch (e) {
          reject(e);
          return;
        }
      }
      checkStatus();
    });
  }
}
function abortPolling() {
  shouldAbortPolling = true;
  clearTimeout(timeoutHandle);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/one-auth-sdk/dist/esm/methods/mfaStatus.js
// module id = 5497
// module chunks = 11